<template>
	<div>
		<notifications></notifications>
		<div :class="{'nav-open': $sidebar.showSidebar}">
			<router-view></router-view>
			<!-- <login v-if="!$store.state.authentication.loggedIn"></login> -->
		</div>

	</div>
</template>

<script>
	// import Login from '@/pages/Login.vue'
	export default {
		components: {
			// Login
		},
		data() {
			return {
				default: null
			}
		},
		created() { }
	}
</script>
<style>
	/* #0d4878 */
	.red {
		color: red;
	}
	.md-textarea {
		min-height: 400px !important;
	}

	.md-list-item-text {
		line-height: 48px !important;
		padding: 0px 18px !important;
	}

	.el-tabs__item.is-active {
		color: #0d4878 !important;
	}

	.el-tabs__item:hover {
		color: #0d4878 !important;
	}

	.el-tabs__active-bar {
		background-color: #0d4878 !important;
	}

	.md-progress-bar-fill {
		background-color: #0d4878 !important;
	}

	.md-progress-bar {
		background-color: #3c7ab736 !important;
	}

	.md-title {
		letter-spacing: 0 !important;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
	.md-list-item-text {
		font-family: "Kantumruy", "Nunito";
	}
	.md-list.md-theme-default .md-selected .md-list-item-content, .md-list.md-theme-default .router-link-exact-active .md-list-item-content {
		color: #0d4878;
	}
	.wrapper {
		height: 100% !important;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container:after {
		background-color: #0d4878 !important;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container {
		border-color: #0d4878 !important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue